import { create } from 'zustand';


export interface AuthState {
    authToken: string;
    updateAuthToken: (authToken: string) => void;
    emailVerified: boolean;
    updateEmailVerified: (emailVerified: boolean) => void;
}

const localAuth = create<AuthState>((set) => ({ 
    authToken: null,
    updateAuthToken: (authToken: string) => set((state: any) => ({ 
        authToken: authToken
    })),
    emailVerified: false,
    updateEmailVerified: (emailVerified: boolean) => set((state: any) => ({ 
        emailVerified: emailVerified
    }))
}));

export default localAuth;